import React, {
    useEffect, useState,
} from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Button from '../../UniformComponents/Button'
import Anchor from '../../UniformComponents/Anchor'
import Tooltip from '../../UniformComponents/Tooltip'
import AddSurveyBranchModal from './AddSurveyBranchModal'
import Badge from '../../UniformComponents/Badge'

const SurveyBranching = (props) => {
    const { store, appStore } = props
    const [loading, setLoading] = useState(true)
    const [branchingData, setBranchingData] = useState([])
    const [showAddBranchModal, setShowAddBranchModal] = useState(false)
    const { closed } = appStore.survey

    const fetchBranches = async () => {
        setLoading(true)
        const data = await appStore.http.get(`/surveyBuilder/surveyBranches/${store.survey.id}?includeArchived=true`)
        setBranchingData(data)
        if (data.length) store.toggleHasChildSurveys(true); else store.toggleHasChildSurveys(false)
        setLoading(false)
    }

    useEffect(() => {
        fetchBranches()
    }, [])

    const toggleAddSurveyBranchModal = () => {
        setShowAddBranchModal(!showAddBranchModal)
    }

    const badgeStatus = {
        active: 'blue',
        'in development': 'purple',
        closed: 'grey',
        archived: 'yellow',
    }

    const badgeStatusNumber = {
        active: 1,
        'in development': 2,
        closed: 3,
        archived: 4,
    }

    return (
        <div style={{ padding: '16px', border: '1px solid #EDF1F7', borderRadius: '8px' }}>
            <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '8px' }}>
                {i18n.t('settings.surveyBranching.branching')}
            </div>

            <div style={{ marginBottom: '12px' }}>
                {i18n.t('settings.surveyBranching.subTitle')}
            </div>

            {!loading
                ? (
                    <div
                        style={{
                            borderRadius: '8px',
                            overflow: 'hidden',
                            border: '1px solid #CADAE1',
                        }}
                    >
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                            }}
                        >
                            <thead style={{ background: '#CADAE1' }}>
                                <tr>
                                    <th style={{
                                        padding: '16px', textAlign: 'left', fontWeight: '600', borderTopLeftRadius: '8px',
                                    }}
                                    >
                                        {i18n.t('settings.surveyBranching.branchName')}
                                    </th>
                                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>
                                        {i18n.t('settings.surveyBranching.createdDate')}
                                    </th>
                                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>
                                        {i18n.t('settings.surveyBranching.surveyResponses')}
                                    </th>
                                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>
                                        {i18n.t('status')}
                                    </th>
                                    <th
                                        style={{
                                            padding: '16px',
                                            textAlign: 'left',
                                            borderTopRightRadius: '8px',
                                        }}
                                    >
                                        {' '}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {branchingData?.map((bd) => (
                                    <tr key={bd.surveyId}>
                                        <td style={{ padding: '16px' }}>{bd.name}</td>
                                        <td style={{ padding: '16px' }}>{bd.createdDate}</td>
                                        <td style={{ padding: '16px' }}>{bd.noOfResponses}</td>
                                        <td style={{ padding: '16px' }}>
                                            <Badge
                                                cssClass="rounded status-badge"
                                                type={badgeStatus[bd.status]}
                                                label={i18n.t(`status_${badgeStatusNumber[bd.status]}`, bd.status)}
                                            />
                                        </td>
                                        <td style={{
                                            padding: '16px',
                                            color: '#8B99A7',
                                            fontSize: '20px',
                                        }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                gap: '24px',
                                            }}
                                            >
                                                {/* <Anchor
                                                    cssClass="icon-link-btn"
                                                    onClick={(e) => e.stopPropagation()}
                                                    href={`/survey/${bd.surveyId}/setup`}
                                                >
                                                    <Tooltip
                                                        text="Archive survey"
                                                        direction="left"
                                                    />
                                                    <i className="fa-light fa-box-archive" />
                                                </Anchor> */}
                                                <Anchor
                                                    cssClass="icon-link-btn"
                                                    onClick={(e) => e.stopPropagation()}
                                                    href={`/survey/${bd.surveyId}/setup`}
                                                    isExternal // to force reload of questions for parent survey tag. Not best method dirty fix for now
                                                >
                                                    <Tooltip
                                                        text={i18n.t('reports_edit')}
                                                        direction="left"
                                                    />
                                                    <i className="fa-light fa-pen-to-square" />
                                                </Anchor>
                                                <Anchor
                                                    cssClass="icon-link-btn"
                                                    onClick={(e) => e.stopPropagation()}
                                                    href={`/survey/${bd.surveyId}/report`}
                                                    isExternal
                                                >
                                                    <Tooltip
                                                        text={i18n.t('reports_view')}
                                                        direction="left"
                                                    />
                                                    <i className="fa-light fa-eye" />
                                                </Anchor>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
                : null}
            <div style={{ marginTop: '12px' }}>
                <Button
                    cssClass="regular"
                    variant="primary"
                    label={i18n.t('settings.surveyBranching.addBranch')}
                    onClick={toggleAddSurveyBranchModal}
                    disabled={closed}
                />
            </div>
            <AddSurveyBranchModal
                store={store}
                showAddBranchModal={showAddBranchModal}
                toggleAddSurveyBranchModal={toggleAddSurveyBranchModal}
                fetchBranches={fetchBranches}
                nextBranchNum={branchingData.length + 1}
            />
        </div>
    )
}

export default observer(SurveyBranching)
